import React from "react"
import { useStaticQuery } from "gatsby"
import Img from "gatsby-image"
import { HeadingText, PortfolioImagesContainer, ImageContainer } from "./styles"

const Portfolio = () => {
  const allImages = useStaticQuery(graphql`
    query {
      allImageSharp(
        sort: { fields: fluid___originalName, order: ASC }
        filter: { fluid: { originalName: { regex: "/portfolio/" } } }
      ) {
        edges {
          node {
            id
            fluid(maxWidth: 500, maxHeight: 700) {
              ...GatsbyImageSharpFluid_withWebp
            }
          }
        }
      }
      fashionFigures: allImageSharp(
        sort: { fields: fluid___originalName, order: ASC }
        filter: { fluid: { originalName: { regex: "/fashion_figure/" } } }
      ) {
        edges {
          node {
            id
            fluid(maxWidth: 500, maxHeight: 700) {
              ...GatsbyImageSharpFluid_withWebp
            }
          }
        }
      }
    }
  `)

  return (
    <>
      <HeadingText>Fashion</HeadingText>
      <PortfolioImagesContainer>
        {allImages.fashionFigures.edges.map((edge, index) => (
          <ImageContainer key={index}>
            <Img fluid={edge.node.fluid} alt="Fashion Figure" />
          </ImageContainer>
        ))}
      </PortfolioImagesContainer>
      <HeadingText>Artwork</HeadingText>
      <PortfolioImagesContainer>
        {allImages.allImageSharp.edges.map((edge, index) => (
          <ImageContainer key={index}>
            <Img fluid={edge.node.fluid} alt="Artwork" />
          </ImageContainer>
        ))}
      </PortfolioImagesContainer>
    </>
  )
}

export default Portfolio
